<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { InputText, Select } from '@fno/component2/form.js'
    import arenaIcons from 'fanx-schema/value/arenaIcons'

    export let context
    export let formKey
    export let index
</script>

<Card>
    <CardBody>
        <Row class="mb-3">
            <Col>
                <InputText
                    label="Venue Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.name"
                    bind:value={context.form[formKey][index].attributes.name}
                    on:change
                />
            </Col>
            <Col>
                <Select
                    required
                    label="Venue Icon"
                    {context}
                    {index}
                    includeDefaultValue
                    options={arenaIcons}
                    {formKey}
                    keypath="attributes.icon"
                    bind:value={context.form[formKey][index].attributes.icon}
                    on:change
                />
            </Col>
        </Row>
        <Row class="mb-3">
            <Col>
                <InputText
                    label="Venue Location - Latitude"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.latitude"
                    bind:value={context.form[formKey][index].attributes.latitude}
                    on:change
                />
            </Col>
            <Col>
                <InputText
                    label="Venue Location - Longitude"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.longitude"
                    bind:value={context.form[formKey][index].attributes.longitude}
                    on:change
                />
            </Col>
        </Row>
    </CardBody>
</Card>
